// The quiz checkpoint's diff/sync decision — pure so the rule ("write
// only what changed") is testable without a server, a clock or React. The
// code that actually fires the write lives on the quote flow's host
// component, which already holds the credential and view state the
// decision needs to be queued against.

import equal from "fast-deep-equal";

import type { QuizResolution } from "./types";

export type CheckpointSyncAction =
  | { kind: "put"; resolution: QuizResolution }
  | { kind: "delete" }
  | { kind: "none" };

/**
 * What the quiz checkpoint should do given what the server currently
 * holds and what the answers on hand now describe. A PUT whose resolution
 * deep-equals the standing row is a no-op server-side too — deciding it
 * here as well means a caller never fires a request it already knows
 * will change nothing.
 */
export function checkpointSyncAction(
  serverResolution: QuizResolution | null,
  derived: QuizResolution | null,
): CheckpointSyncAction {
  if (equal(serverResolution, derived)) return { kind: "none" };
  if (derived === null) return { kind: "delete" };
  return { kind: "put", resolution: derived };
}
